//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    directives: {
        autofocus: {
            inserted(el, binding) {
                if (binding.value) {
                    el.focus();
                }
            },
        },
    },
    model: {
        prop: 'vModel',
        event: 'change',
    },
    props: {
        vModel: {
            type: String,
            required: true,
            default: '',
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: 'Search',
        },
        debounceMs: {
            type: Number,
            default: 250,
        },
        background: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        alignRight: {
            type: Boolean,
            default: false,
        },
        inputOptions: {
            type: Object,
            default: null,
        },
        clickFunction: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            debounceTimeout: 0,
        };
    },
    computed: {
        uniqueID() {
            return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        },
    },
    methods: {
        /** @param {InputEvent} $event */
        valueChanged($event) {
            const target = /** @type {HTMLInputElement} */($event.target);
            this.dispatchEventAfterDebounce(target.value);
        },
        /** @param {String} value The new value of input */
        dispatchEventAfterDebounce(value) {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }

            // @ts-ignore
            this.debounceTimeout = setTimeout(() => {
                this.debounceTimeout = 0;
                this.$emit('change', value);
            }, this.debounceMs);
        },
        blur() {
            this.$emit('blur');
        },
        focus() {
            this.$emit('focus');
        },
    },
};
